// extracted by mini-css-extract-plugin
export var text_container = "textSmallComponent-module--text_container--8922e";